import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { Card, StatusIconProtoProps } from '@nike/eds';
import './guest-pass.css';
import { usePassPolicies } from '../../../context/PassPolicy';
import { GuestForm } from './guest-from/guest-form';
import dayjs from 'dayjs';
import { VisitorPass } from '../../../models/IVisitorPass';
import { GuestPassRequest } from '../../../models/IGuestPass';
import { useSponsorContext } from '../../../context/Sponsor';
import { dateFormat } from '../../../utils/date-helper';

export interface Props {
  onDismiss: () => void;
  setSnackBar: Dispatch<
    SetStateAction<{
      showSnack: boolean;
      message: string;
      snackStatus: StatusIconProtoProps['status'];
    }>
  >;
  guestPassToEdit: VisitorPass | null;
  isModleOpen: boolean;
}
export const Guest: FC<Props> = ({ onDismiss, setSnackBar, guestPassToEdit, isModleOpen }) => {
  const passPoliciesContext = usePassPolicies();
  const guestPassPolicies = passPoliciesContext.passPolicies
    .filter(x => x.passTypeId === 10)
    .sort((a, b) =>
      dayjs(a.availableEndDate || a.shoppingStartDate).diff(
        dayjs(b.availableEndDate || b.shoppingStartDate),
      ),
    );
  const { sponsor } = useSponsorContext();
  const [selectedCard, setSelectedCard] = useState<number>(0);
  const [guestPass, setGuestPass] = useState<GuestPassRequest>();

  useEffect(() => {
    const index =
      guestPassPolicies.findIndex(x => x.passPolicyId === guestPassToEdit?.passPolicyId) > 0
        ? guestPassPolicies.findIndex(x => x.passPolicyId === guestPassToEdit?.passPolicyId)
        : 0;
    setSelectedCard(index);
  }, [guestPassToEdit]);

  const handleCardClick = (index: number) => {
    setSelectedCard(index);
  };

  useEffect(() => {
    if (guestPassPolicies.length > 0) {
      if (guestPassToEdit?.passId ?? 0 > 0) {
        const editPass: GuestPassRequest = {
          passId: guestPassToEdit?.passId ?? null,
          firstName: guestPassToEdit?.firstName ?? '',
          lastName: guestPassToEdit?.lastName ?? '',
          emailAddress: guestPassToEdit?.emailAddress ?? '',
          guestEmailLanguage: guestPassToEdit?.guestEmailLanguage ?? '',
          shoppingDateStart: dayjs(guestPassToEdit?.shoppingDateStart).format('YYYY-MM-DD') ?? '',
          shoppingDateEnd: dayjs(guestPassToEdit?.shoppingDateEnd).format('YYYY-MM-DD') ?? '',
          passLocationId: guestPassToEdit?.passLocationId ?? 0,
          timeSlotId: guestPassToEdit?.timeSlotId ?? 0,
          govtComplianceChecked: guestPassToEdit?.govtComplianceChecked ?? false,
        };
        setGuestPass(editPass);
      } else {
        const isSingleDay =
          !!guestPassPolicies &&
          dateFormat(guestPassPolicies[selectedCard].shoppingStartDate) ===
            dateFormat(guestPassPolicies[selectedCard].shoppingEndDate);
        const guestInitValues: GuestPassRequest = {
          passId: null,
          firstName:
            !!guestPassPolicies && guestPassPolicies[selectedCard].selfInviteOnly
              ? sponsor?.firstName
              : '',
          lastName:
            !!guestPassPolicies && guestPassPolicies[selectedCard].selfInviteOnly
              ? sponsor?.lastName
              : '',
          emailAddress: '',
          shoppingDateStart:
            !!guestPassPolicies && isSingleDay
              ? dateFormat(guestPassPolicies[selectedCard].shoppingStartDate)
              : '',
          shoppingDateEnd:
            !!guestPassPolicies && isSingleDay
              ? dateFormat(guestPassPolicies[selectedCard].shoppingStartDate)
              : '',
          guestEmailLanguage: '',
          passLocationId: 0,
          timeSlotId: 0,
          govtComplianceChecked: false,
        };
        setGuestPass(guestInitValues);
      }
    }
  }, [selectedCard]);
  useEffect(() => {
    if (!isModleOpen && selectedCard !== 0) {
      setSelectedCard(0);
    }
  }, [isModleOpen]);

  return (
    <div className="pass_modal_width">
      <Card className="eds-spacing--p-24 section-border">
        <div className="guest__card-container ">
          {guestPassPolicies.map((pass, index) => (
            <Card
              className={`guest__card ${selectedCard === index ? 'selected' : `card_guest_color ${pass.passesAllowed !== 0 && (pass.passesUsed || 0) >= (pass.passesAllowed || 0) ? 'disabled' : ''}`}`}
              key={pass.passPolicyId}
              title={pass.displayName}
              role="button"
              onClick={() => handleCardClick(index)}
            >
              <h3 className="txt_font">{pass.displayName.toUpperCase()}</h3>
              <p className="span_font">
                ({new Date(pass.shoppingStartDate).toLocaleDateString()} -{' '}
                {new Date(pass.availableEndDate).toLocaleDateString()})
              </p>
              {pass.passesAllowed > 0 ? (
                <p className="span_font">
                  {pass.passesAllowed - (pass.passesUsed || 0)} of {pass.passesAllowed} passes
                  available
                </p>
              ) : (
                <p className="span_font">Unlimited passes</p>
              )}
            </Card>
          ))}
        </div>
      </Card>
      {!!guestPassPolicies && !!guestPassPolicies[selectedCard] && guestPass && (
        <GuestForm
          passPolicy={
            guestPassPolicies.find(
              x => x.passPolicyId === guestPassPolicies[selectedCard].passPolicyId,
            ) ?? guestPassPolicies[selectedCard]
          }
          guestPassToEdit={guestPass}
          onDismiss={onDismiss}
          setSnackbar={setSnackBar}
        />
      )}
    </div>
  );
};
